"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddInputFields = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _theme = require("../../styles/theme");

var _base = require("../../base");

var _buttons = require("../buttons");

var _inputs = require("../inputs");

var _icons = require("../../ui_elements/icons");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

var AddFieldsWrapper = (
/*#__PURE__*/
0, _styledBase.default)('div', {
  target: "e1k2suwb0",
  label: "AddFieldsWrapper"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
var FieldsWrapper = (
/*#__PURE__*/
0, _styledBase.default)('div', {
  target: "e1k2suwb1",
  label: "FieldsWrapper"
})(_base.Row, "{display:flex;&:only-child{", _icons.Icon, "{display:none;}}}", _inputs.Input, "{order:1;}", _icons.Icon, "{width:30px;order:2;&:hover{cursor:pointer;& + ", _inputs.Input, "{border-color:", _theme.colors.red.primary, ";}}}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2Zvcm0vYWRkX2ZpZWxkcy9pbmRleC5qc3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBYW1DIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2Zvcm0vYWRkX2ZpZWxkcy9pbmRleC5qc3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcblxuaW1wb3J0IHsgY29sb3JzIH0gZnJvbSAnLi4vLi4vc3R5bGVzL3RoZW1lJztcblxuaW1wb3J0IHsgUm93IH0gZnJvbSAnLi4vLi4vYmFzZSc7XG5pbXBvcnQgeyBCdXR0b24gfSBmcm9tICcuLi9idXR0b25zJztcbmltcG9ydCB7IElucHV0IH0gZnJvbSAnLi4vaW5wdXRzJztcbmltcG9ydCB7IEljb24gfSBmcm9tICcuLi8uLi91aV9lbGVtZW50cy9pY29ucyc7XG5cbmNvbnN0IEFkZEZpZWxkc1dyYXBwZXIgPSBzdHlsZWQoJ2RpdicpYGA7XG5cbmNvbnN0IEZpZWxkc1dyYXBwZXIgPSBzdHlsZWQoJ2RpdicpYFxuICAke1Jvd30ge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgJjpvbmx5LWNoaWxkIHtcbiAgICAgICR7SWNvbn0ge1xuICAgICAgICBkaXNwbGF5OiBub25lO1xuICAgICAgfVxuICAgIH1cbiAgfVxuICAke0lucHV0fSB7XG4gICAgb3JkZXI6IDE7XG4gIH1cbiAgJHtJY29ufSB7XG4gICAgd2lkdGg6IDMwcHg7XG4gICAgb3JkZXI6IDI7XG4gICAgJjpob3ZlciB7XG4gICAgICBjdXJzb3I6IHBvaW50ZXI7XG4gICAgICAmICsgJHtJbnB1dH0ge1xuICAgICAgICBib3JkZXItY29sb3I6ICR7Y29sb3JzLnJlZC5wcmltYXJ5fTtcbiAgICAgIH1cbiAgICB9XG4gIH1cbmA7XG5cbmV4cG9ydCBjb25zdCBBZGRJbnB1dEZpZWxkcyA9ICh7IGlucHV0UHJvcHMsIHZhbHVlLCBvbkNoYW5nZSB9KSA9PiB7XG4gIGNvbnN0IGhhbmRsZUNoYW5nZSA9IChzdHIsIGluZGV4KSA9PiB7XG4gICAgY29uc3QgbmV3VmFsdWUgPSBbLi4udmFsdWVdO1xuICAgIG5ld1ZhbHVlLnNwbGljZShpbmRleCwgMSwgc3RyKTtcbiAgICBvbkNoYW5nZShuZXdWYWx1ZSk7XG4gIH07XG5cbiAgY29uc3QgYWRkSW5wdXQgPSAoKSA9PiB7XG4gICAgY29uc3QgbmV3VmFsdWUgPSBbLi4udmFsdWVdO1xuICAgIG5ld1ZhbHVlLnB1c2goJycpO1xuICAgIG9uQ2hhbmdlKG5ld1ZhbHVlKTtcbiAgfTtcblxuICBjb25zdCByZW1vdmVJbnB1dCA9IGluZGV4ID0+IHtcbiAgICBjb25zdCBuZXdWYWx1ZSA9IFsuLi52YWx1ZV07XG4gICAgbmV3VmFsdWUuc3BsaWNlKGluZGV4LCAxKTtcbiAgICBvbkNoYW5nZShuZXdWYWx1ZSk7XG4gIH07XG5cbiAgY29uc3QgcmVuZGVySW5wdXRzID0gKCkgPT4ge1xuICAgIHJldHVybiB2YWx1ZS5tYXAoKHZhbCwgaSkgPT4ge1xuICAgICAgcmV0dXJuIChcbiAgICAgICAgLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIHJlYWN0L25vLWFycmF5LWluZGV4LWtleVxuICAgICAgICA8Um93IHNpemU9XCJ0aW55XCIga2V5PXtgYWRkYWJsZS1pbnB1dC0ke2l9YH0+XG4gICAgICAgICAgPEljb24gdHlwZT1cInhcIiBvbkNsaWNrPXsoKSA9PiByZW1vdmVJbnB1dChpKX0gLz5cbiAgICAgICAgICA8SW5wdXRcbiAgICAgICAgICAgIHsuLi5pbnB1dFByb3BzfVxuICAgICAgICAgICAgb25DaGFuZ2U9e2V2dCA9PiBoYW5kbGVDaGFuZ2UoZXZ0LmN1cnJlbnRUYXJnZXQudmFsdWUsIGkpfVxuICAgICAgICAgICAgdmFsdWU9e3ZhbHVlW2ldfVxuICAgICAgICAgICAgaWQ9e2Ake2lucHV0UHJvcHMuaWR9WyR7aX1dYH1cbiAgICAgICAgICAvPlxuICAgICAgICA8L1Jvdz5cbiAgICAgICk7XG4gICAgfSk7XG4gIH07XG5cbiAgcmV0dXJuIChcbiAgICA8QWRkRmllbGRzV3JhcHBlcj5cbiAgICAgIDxGaWVsZHNXcmFwcGVyPntyZW5kZXJJbnB1dHMoKX08L0ZpZWxkc1dyYXBwZXI+XG5cbiAgICAgIDxSb3cgc2l6ZT1cInRpbnlcIj5cbiAgICAgICAgPEJ1dHRvbiB0eXBlPVwiYnV0dG9uXCIgc2l6ZT1cInNtYWxsXCIgdmFyaWFudD1cInNlY29uZGFyeVwiIG9uQ2xpY2s9e2FkZElucHV0fT5cbiAgICAgICAgICA8SWNvbiB0eXBlPVwicGx1c1wiIHdpdGhUZXh0IC8+XG4gICAgICAgICAgQWRkXG4gICAgICAgIDwvQnV0dG9uPlxuICAgICAgPC9Sb3c+XG4gICAgPC9BZGRGaWVsZHNXcmFwcGVyPlxuICApO1xufTtcblxuQWRkSW5wdXRGaWVsZHMucHJvcFR5cGVzID0ge1xuICB2YWx1ZTogUHJvcFR5cGVzLmFycmF5T2YoUHJvcFR5cGVzLnN0cmluZyksXG4gIGlucHV0UHJvcHM6IFByb3BUeXBlcy5zaGFwZSh7XG4gICAgaWQ6IFByb3BUeXBlcy5zdHJpbmcsXG4gICAgbmFtZTogUHJvcFR5cGVzLnN0cmluZyxcbiAgICBwbGFjZWhvbGRlcjogUHJvcFR5cGVzLnN0cmluZ1xuICB9KS5pc1JlcXVpcmVkLFxuICBvbkNoYW5nZTogUHJvcFR5cGVzLmZ1bmNcbn07XG5cbkFkZElucHV0RmllbGRzLmRlZmF1bHRQcm9wcyA9IHtcbiAgdmFsdWU6IFsnJ10sXG4gIG9uQ2hhbmdlOiAoKSA9PiB7fVxufTtcbiJdfQ== */"));

var AddInputFields = function AddInputFields(_ref) {
  var inputProps = _ref.inputProps,
      value = _ref.value,
      onChange = _ref.onChange;

  var handleChange = function handleChange(str, index) {
    var newValue = _toConsumableArray(value);

    newValue.splice(index, 1, str);
    onChange(newValue);
  };

  var addInput = function addInput() {
    var newValue = _toConsumableArray(value);

    newValue.push('');
    onChange(newValue);
  };

  var removeInput = function removeInput(index) {
    var newValue = _toConsumableArray(value);

    newValue.splice(index, 1);
    onChange(newValue);
  };

  var renderInputs = function renderInputs() {
    return value.map(function (val, i) {
      return (// eslint-disable-next-line react/no-array-index-key
        _react.default.createElement(_base.Row, {
          size: "tiny",
          key: "addable-input-".concat(i)
        }, _react.default.createElement(_icons.Icon, {
          type: "x",
          onClick: function onClick() {
            return removeInput(i);
          }
        }), _react.default.createElement(_inputs.Input, _extends({}, inputProps, {
          onChange: function onChange(evt) {
            return handleChange(evt.currentTarget.value, i);
          },
          value: value[i],
          id: "".concat(inputProps.id, "[").concat(i, "]")
        })))
      );
    });
  };

  return _react.default.createElement(AddFieldsWrapper, null, _react.default.createElement(FieldsWrapper, null, renderInputs()), _react.default.createElement(_base.Row, {
    size: "tiny"
  }, _react.default.createElement(_buttons.Button, {
    type: "button",
    size: "small",
    variant: "secondary",
    onClick: addInput
  }, _react.default.createElement(_icons.Icon, {
    type: "plus",
    withText: true
  }), "Add")));
};

exports.AddInputFields = AddInputFields;
AddInputFields.propTypes = {
  value: _propTypes.default.arrayOf(_propTypes.default.string),
  inputProps: _propTypes.default.shape({
    id: _propTypes.default.string,
    name: _propTypes.default.string,
    placeholder: _propTypes.default.string
  }).isRequired,
  onChange: _propTypes.default.func
};
AddInputFields.defaultProps = {
  value: [''],
  onChange: function onChange() {}
};